import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { AiOutlineEdit } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { formatAmount } from "../../Utility/functions/Helper";
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const CampaignUser = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [createBou, setCreateBon] = useState(false);
  const [images, setImages] = useState("");
  const [editData, setEditData] = useState({});

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchBounsData();
  }, []);

  const fetchBounsData = async (data) => {
    let url = `${endPoints.api.GET_ALL_CAMPAIGN_USERS}`;
    setIsLoading(true);
    await getAllData(url, data)
      .then((response) => {
        console.log("data", response.data);
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Campaign User
                  </h3>
                  <Button
                    variant="primary"
                    className="mrglft10"
                    style={{ height: "fit-content" }}
                    onClick={() => {
                      navigate("/campaign");
                    }}
                  >
                    Go Back
                  </Button>
                </div>
              </div>

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            {/* Date issued
                          Bonus Type
                          Amount
                          Amount consumed of the bonus
                          Expired amount
                          promocode
                          Person, user or system that issued the bonus  */}
                            <TableCell align="center">Campaign ID </TableCell>
                            <TableCell align="center"> Customer ID </TableCell>
                            <TableCell align="center">Date Issued</TableCell>
                            <TableCell align="center">Expiry Date </TableCell>

                            <TableCell align="center"> Bonus Type</TableCell>

                            <TableCell align="center"> Amount</TableCell>
                            <TableCell align="center">
                              {" "}
                              Amount Consumed{" "}
                            </TableCell>

                            <TableCell align="center">
                              {" "}
                              Expired amount
                            </TableCell>

                            <TableCell align="center"> Promocode</TableCell>
                            {/* <TableCell align="center">
                              {" "}
                              Person/user/system issued bonus{" "}
                            </TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? rows.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : rows
                          ).map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center">
                                {row.idCampain}
                              </TableCell>
                              <TableCell align="center">{row.idUser}</TableCell>
                              <TableCell align="center">
                                {moment
                                  .utc(row.issueDate)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>
                              <TableCell align="center">
                                {moment
                                  .utc(row.expiryDate)
                                  .format("MMMM Do YYYY, h:mm a")}
                              </TableCell>

                              <TableCell align="center">
                                {/* {getBounsType(row.bonusType)} */}
                                {row.bonusType == 1
                                  ? "Cash"
                                  : row.bonusType == 2
                                  ? "Bouns"
                                  : row.bonusType == 3
                                  ? "Coupon"
                                  : row.bonusType}
                              </TableCell>
                              <TableCell align="center">$ {formatAmount(row.amount)}</TableCell>
                              <TableCell align="center">$ {formatAmount(row.amountConsumed)}</TableCell>
                              <TableCell align="center">$ {formatAmount(row.expiredAmount)}</TableCell>
                              <TableCell align="center">
                                {row.promocode}
                              </TableCell>

                              {/* <TableCell align="center">{row.usedBy}</TableCell>
                               */}
                            </TableRow>
                          ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignUser;
